import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import CardHeader from 'components/CardHeader';
import SpecialGoalCard from 'components/SpecialGoalCard';
import GoalCardWrapper from 'components/GoalCard/Wrapper';
import connectToStores from 'decorators/connectToStores';
import withStyles from 'decorators/withStyles';
import cx from './Specials.scss';
import loopIndex from 'utils/loopIndex';

@withStyles(cx)
@connectToStores({
  goals: store => {
    return { goals: store.state.goals };
  },
  goalsList: store => {
    return { items: store.state.specials };
  },
})
export default class Specials extends React.Component {

  static propTypes = {
    items: ImmutablePropTypes.list.isRequired,
    goals: ImmutablePropTypes.map.isRequired,
    flux: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      i: 0,
    };

    if(!process.env.IS_NODE) {
      props.goals.forEach(goal => {
        const image = new Image();
        image.src = goal.get('imgBg');
      });
    }
  }

  handleNav(direction) {
    const { i } = this.state;
    this.setState({
      i: loopIndex(i + direction, 0, this.props.items.size - 1),
    });
  }

  render() {
    const { i } = this.state;
    const { items } = this.props;
    const goals = items.map(id => this.props.goals.get(id)).toList();

    if(goals.size === 0) {
      return null;
    }

    return (
      <GoalCardWrapper style={{ minHeight: 350 }}>
        <div className={cx('main')}>
          <CardHeader
            onPrevClick={goals.size > 1 ? (() => this.handleNav(-1)) : undefined}
            onNextClick={goals.size > 1 ? (() => this.handleNav(+1)) : undefined}
          >
            <a href="/site/special">
              {__('goal.special_projects')}
            </a>
          </CardHeader>
          <CSSTransitionGroup transitionEnterTimeout={300} transitionLeaveTimeout={300} transitionName="t-fade">
            {goals.get(i) && this.renderGoal(goals.get(i))}
          </CSSTransitionGroup>
        </div>
      </GoalCardWrapper>
    );
  }

  renderGoal(goal) {
    const goalsActions = this.props.flux.getActions('goals');
    return (
      <SpecialGoalCard
        wrapperSize="1"
        goal={goal}
        key={goal.get('id')}
        onUnsubscribe={() => goalsActions.unsubscribe(goal.get('id'))}
        onSubscribe={() => goalsActions.subscribe(goal.get('id'))}
        onLike={() => goalsActions.like(goal.get('id'))}
        />
    );
  }

}



// WEBPACK FOOTER //
// ./src/react/elements/GoalsPage/Specials.js